<template>
  <div class="ai-generate-and-stop-button">
    <!-- STOP BUTTON -->
    <div v-if="!isDoneGenerating">
      <div class="generator_stop-icon" v-tooltip="stopButtonTooltip">
        <div
          class="generator_stop-icon-loading"
        />
        <aha-icon
          name="stop-dark"
          class="generator_stop-icon-svg"
          width="16"
          height="16"
          viewBox="0 0 20 20"
        ></aha-icon>
        <div class="generator_stop-background"></div>
      </div>
    </div>

    <!-- GENERATE BUTTON -->
    <aha-icon
      v-if="isDoneGenerating"
      name="send-button"
      v-tooltip="generateButtonTooltip"
      class="generate_send-icon"
      :class="generateButtonIconClass"
    />
    <div class="aha-textarea__button-bg" :class="{'hidden': isGenerateButtonDisabled}"></div>
  </div>
</template>

<script>
export default {
  props: {
    isDoneGenerating: {
      type: Boolean,
      default: false,
    },
    isSendingAIRequest: {
      type: Boolean,
      default: false,
    },
    isAIRequestingOrGeneratingSlides: {
      type: Boolean,
      default: false,
    },
    isGenerateButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stopButtonTooltip() {
      return this.$i18nPresenter.t('Stop generating')
    },
    generateButtonTooltip() {
      return (this.isSendingAIRequest || !this.isDoneGenerating) ? '' : this.$i18nPresenter.t('Submit')
    },
    generateButtonIconClass() {
      return this.isGenerateButtonDisabled ? 'text-base-40 cursor-not-allowed' : 'text-secondary-100'
    },
  },
}
</script>

<style lang="scss" scope>
.ai-generate-and-stop-button {
  @apply relative z-1;
  &:hover, &:active {
    .aha-textarea__button-bg {
      @apply bg-secondary-15 rounded-full absolute opacity-100;
      width: 32px;
      height: 32px;
      right: 1px;
      top: 0;
      z-index: -1;
    }
  }
}
.generator_stop-icon {
  position: relative;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    .generator_stop-background {
      @apply bg-secondary-15 rounded-full absolute opacity-100;
      width: 32px;
      height: 32px;
      left: -5px;
      top: -4px;
      z-index: -1;
}
  }
  .generator_stop-background {
    @apply opacity-0 transition-opacity duration-200;
  }
}
.generator_stop-icon-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  border: 2px solid rgba(49, 49, 49, 0.3);
  border-top-color: #313131;
}
.generator_stop-icon-svg {
  position: absolute;
  border-radius: 50%;
  background-color: #ffffff;
}

</style>
